import React, { FunctionComponent } from 'react'
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../../utils/themes/ThemeProvider'

type Props = {
  width?: number | string
  height?: number | string
}

export const WorkLifeServicesBenefitIllustration: FunctionComponent<Props> = ({ width = 66, height = 65 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { benefitIllustration } = colors.icons
  return (
    <Svg width={width} height={height} viewBox='0 0 66 65' fill='none'>
      <G clipPath='url(#clip0_4102_105833)'>
        <Path
          d='M28.4749 39.2612C28.4749 38.6188 28.5386 37.9926 28.6342 37.3746C24.8429 35.8377 22.0314 32.3572 21.3703 28.1287C17.0295 29.877 13.9551 34.195 13.9551 39.2612C13.9551 45.8805 19.2118 51.2476 25.6952 51.2476C28.443 51.2476 30.9599 50.2799 32.9591 48.6698C30.2351 46.4742 28.4829 43.0832 28.4829 39.2612H28.4749Z'
          fill={benefitIllustration.primary.fill}
        />
        <Path
          d='M44.532 28.1199C43.8709 32.3485 41.0593 35.8371 37.2681 37.3659C37.3637 37.9839 37.4274 38.6101 37.4274 39.2525C37.4274 43.0663 35.6751 46.4654 32.9512 48.661C34.9503 50.2712 37.4672 51.2389 40.2151 51.2389C46.6984 51.2389 51.9552 45.8718 51.9552 39.2525C51.9552 34.1945 48.8807 29.8764 44.532 28.1118V28.1199Z'
          fill={benefitIllustration.primary.fill}
        />
        <Path
          d='M37.4358 39.2609C37.4358 38.6184 37.3721 37.9923 37.2765 37.3743C35.9384 37.9191 34.4809 38.22 32.9596 38.22C31.4383 38.22 29.9808 37.911 28.6427 37.3743C28.5471 37.9923 28.4834 38.6184 28.4834 39.2609C28.4834 43.0747 30.2357 46.4738 32.9596 48.6694C35.6836 46.4738 37.4358 43.0828 37.4358 39.2609Z'
          fill={benefitIllustration.secondary.fill}
        />
        <Path
          d='M32.9579 29.8524C34.957 28.2423 37.4739 27.2746 40.2218 27.2746C41.751 27.2746 43.2006 27.5836 44.5387 28.1203C44.6342 27.5023 44.698 26.8761 44.698 26.2337C44.698 19.6143 39.4412 14.2473 32.9579 14.2473C26.4745 14.2473 21.2178 19.6143 21.2178 26.2337C21.2178 26.8761 21.2815 27.5023 21.3771 28.1203C22.7152 27.5754 24.1727 27.2746 25.694 27.2746C28.4418 27.2746 30.9587 28.2423 32.9579 29.8524Z'
          fill={benefitIllustration.primary.fill}
        />
        <Path
          d='M28.636 37.3658C29.1059 34.3245 30.6909 31.6735 32.9529 29.852C30.9537 28.2419 28.4368 27.2742 25.689 27.2742C24.1597 27.2742 22.7102 27.5832 21.3721 28.1199C22.0252 32.3485 24.8447 35.837 28.636 37.3658Z'
          fill={benefitIllustration.secondary.fill}
        />
        <Path
          d='M32.959 29.8526C35.221 31.6742 36.806 34.3333 37.2759 37.3746C41.0671 35.8377 43.8787 32.3572 44.5398 28.1287C43.2017 27.5838 41.7441 27.283 40.2229 27.283C37.475 27.283 34.9581 28.2507 32.959 29.8608V29.8526Z'
          fill={benefitIllustration.secondary.fill}
        />
        <Path
          d='M32.9595 29.8521C30.6975 31.6737 29.1125 34.3328 28.6426 37.366C29.9807 37.9108 31.4382 38.2117 32.9595 38.2117C34.4808 38.2117 35.9383 37.9027 37.2764 37.366C36.8065 34.3247 35.2215 31.6737 32.9595 29.844V29.8521Z'
          fill={benefitIllustration.primary.fill}
        />
      </G>
      <Defs>
        <ClipPath id='clip0_4102_105833'>
          <Rect width={38} height={37} fill='white' transform='translate(13.9561 14.2471)' />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
